module.exports = __webpack_public_path__ + "img/fb.ae568850.svg";